module.exports = __webpack_public_path__ + "ec0379a21f2151d346cd8120dc26d5d4.svg";